document.addEventListener('DOMContentLoaded', () => {
  const thumbnails = document.querySelectorAll('.cpi-thumbnail');
  const mainImage = document.getElementById('cpi-main-img');

  if (!thumbnails.length || !mainImage) return;

  thumbnails.forEach(thumbnail => {
    // We use mouseenter for desktop hovering
    thumbnail.addEventListener('mouseenter', function() {
      // Remove active class from all
      thumbnails.forEach(t => t.classList.remove('active'));
      
      // Add active class to current
      this.classList.add('active');
      
      // Get the high-res source
      const newSrc = this.getAttribute('data-src');
      
      // Prevent reloading if already same source
      if (mainImage.src === newSrc) return;

      // Simple fade effect
      mainImage.classList.add('fade-out');
      
      setTimeout(() => {
        mainImage.src = newSrc;
        mainImage.onload = () => {
          mainImage.classList.remove('fade-out');
        };
      }, 150); // Matches the CSS transition time roughly
    });
    
    // Also support click for mobile or general interaction
    thumbnail.addEventListener('click', function() {
      // Same logic as mouseenter
      thumbnails.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      const newSrc = this.getAttribute('data-src');
      if (mainImage.src === newSrc) return;
      mainImage.classList.add('fade-out');
      setTimeout(() => {
        mainImage.src = newSrc;
        mainImage.onload = () => {
          mainImage.classList.remove('fade-out');
        };
      }, 150);
    });
  });
});
